import { render, staticRenderFns } from "./ChangeApproval.vue?vue&type=template&id=561501cd&scoped=true"
import script from "./ChangeApproval.vue?vue&type=script&lang=js"
export * from "./ChangeApproval.vue?vue&type=script&lang=js"
import style0 from "./ChangeApproval.vue?vue&type=style&index=0&id=561501cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561501cd",
  null
  
)

export default component.exports